export const PROPS_SET = "props_set";
export const MESSAGE = "message";
export const ON_JOIN = "on_join";
export const ON_LEAVE = "on_leave";
// export const ON_METADATA_UPDATE = "on_metadata_update";
export const ON_PROPS_SET = "on_props_set";
export const ON_REQUEST = "on_request";
